import "./SimpleModal.scss"
import { FC } from "react"
import GenericModal from "../GenericAppModal/GenericModal.component"
import { RootState } from "../../../redux/store"
import { useAppSelector } from "../../../redux/hooks"

type SimpleModalProps = {
  open: boolean
  handleClose: () => void
}

const SimpleModal: FC<SimpleModalProps> = ({ open, handleClose }) => {
  const modalData: any = useAppSelector((state: RootState) => state.modal.data)

  return (
    <GenericModal
      open={open}
      handleClose={handleClose}
      title={modalData?.title || ""}
      image={modalData?.image || ""}
      description={modalData?.description || ""}
      description2={modalData?.description2 || ""}
      className={`simple-modal ${modalData?.className || ""}`}
    ></GenericModal>
  )
}

export default SimpleModal
